import React, { Component } from 'react'
import SearchBar from '@common/SearchBar'
import { Input, Select, DatePicker } from 'hljd'
import { observer } from 'mobx-react'
import style from '../style.module.less'
import { getDateTypeList, FRANCHISE_STATUS_LIST } from '../../constant'
import isEmpty from 'lodash/isEmpty'

const { RangePicker } = DatePicker

const Item = SearchBar.Item
const Option = Select.Option

@observer
export default class extends Component {
  componentDidMount() {
    this.props.store.getSourceList()

    const { franchise_status, user_phone } = this.props.query
    const params = {}
    if (franchise_status) {
      params.franchise_status = [franchise_status]
    }

    if (user_phone) {
      params.searchValue = user_phone
    }

    if (!isEmpty(params)) {
      // 这里因为 searchValue 在 noNeed 中，导致设置 searchValue 后需要手动 getList
      if (params.searchValue) {
        this.searchBar.setFieldsValue(params)
        this.props.store.$getList(1)
        return
      }

      this.searchBar.setFieldsValue(params)
      return
    }

    this.props.store.$getList(1)
  }

  render() {
    const { store } = this.props
    const { sourceList, staffList } = store
    const searchProp = {
      optionFilterProp: 'children',
      filterOption: (input, option) =>
        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }

    return (
      <div className={style['search-bar-wrap']}>
        <SearchBar
          onInited={searchBar => (this.searchBar = searchBar)}
          store={store}
          noNeed={['searchValue', 'date_type']}
          onAfterReset={(obj, noNeed) => store.resetAll(obj, noNeed)}
        >
          <Item name="searchKey" initialValue="1">
            <Select style={{ width: 88 }}>
              <Option value="1">手机号</Option>
              <Option value="2">姓名</Option>
            </Select>
          </Item>
          <Item name="searchValue">
            <Input placeholder="请输入" style={{ width: 160 }} />
          </Item>

          <Item name="date_type" initialValue="created_at">
            <Select style={{ width: 110 }}>
              {getDateTypeList().map(({ title, value }) => (
                <Option key={value} value={value}>
                  {title}
                </Option>
              ))}
            </Select>
          </Item>

          <Item name="date">
            <RangePicker />
          </Item>

          <Item label="阶段" name="franchise_status" initialValue={[]}>
            <Select
              placeholder="请选择"
              style={{ width: 200 }}
              mode="multiple"
              {...searchProp}
            >
              {FRANCHISE_STATUS_LIST.map(({ title, value }) => (
                <Option key={value} value={value}>
                  {title}
                </Option>
              ))}
            </Select>
          </Item>

          <Item label="来源" name="source" initialValue={[]}>
            <Select
              placeholder="请选择"
              style={{ width: 200 }}
              mode="multiple"
              {...searchProp}
            >
              {sourceList.map(({ id, name }) => {
                return (
                  <Option key={id} value={id}>
                    {name}
                  </Option>
                )
              })}
            </Select>
          </Item>

          <Item label="负责人" name="merchant_support_ids" initialValue={[]}>
            <Select
              placeholder="请选择"
              style={{ width: 200 }}
              mode="multiple"
              {...searchProp}
            >
              {staffList.map(({ value, label }) => (
                <Option key={value} value={value}>
                  {label}
                </Option>
              ))}
            </Select>
          </Item>
        </SearchBar>
      </div>
    )
  }
}
